import type { AiAppCenterModule } from '../types'

export const ticketingModule: AiAppCenterModule = {
  key: 'ticketing',
  label: 'AI智慧票务',
  desc: '票种设置 / 售票管理 / 验票核销',
  path: '/ticketing',
  homePath: '/ticketing/platform/dashboard',
  homeTitles: ['概况', '票务概况'],
  icon: 'ep:ticket',
  color: '#e05555'
}
